import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useAuth } from "../auth";
import { TripCtx } from "./TripLayout";
import { MapPin } from "lucide-react";

export default function ExplorePage() {
  const { tripId } = useParams();
  const { API, authHeaders } = useAuth();
  const { trip } = useContext(TripCtx);
  const [recs, setRecs] = useState([]);
  useEffect(() => { axios.get(`${API}/trips/${tripId}/explore`, { headers: authHeaders }).then((r) => setRecs(r.data)); }, [tripId]);

  return (
    <div data-testid="explore-page" className="py-4">
      <p className="tcm-eyebrow">Curated for you · {trip.destination}</p>
      <h1 className="font-display text-4xl mt-2">Explore</h1>
      <hr className="tcm-gold-rule w-16 my-6" />
      <div className="space-y-6">
        {recs.length === 0 && <p className="text-sm text-[color:var(--tcm-navy-70)] py-6">Recommendations coming soon.</p>}
        {recs.map((r) => (
          <div key={r.id} className="tcm-double-frame" data-testid={`explore-${r.id}`}>
            <div className="tcm-inner p-6">
              {r.category && <p className="tcm-eyebrow" style={{color: "var(--tcm-gold)"}}>{r.category}</p>}
              <p className="font-display text-2xl mt-1">{r.title}</p>
              {r.description && <p className="text-sm mt-2 text-[color:var(--tcm-navy-70)]">{r.description}</p>}
              {r.address && <p className="text-sm mt-2">{r.address}</p>}
              {r.map_link && (
                <a href={r.map_link} target="_blank" rel="noreferrer" className="mt-4 tcm-btn-outline inline-flex items-center gap-2">
                  <MapPin size={12} /> Open in maps
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
